// extracted by mini-css-extract-plugin
export default {"auto":"Icon_auto__xsSQw","xSmall":"Icon_xSmall__NmJXp","small":"Icon_small__GkNF-","medium":"Icon_medium__LKzWR","large":"Icon_large__yYXjb","xLarge":"Icon_xLarge__tfbGD"};